import TradePage from "./TradePage";
import { trades } from "@/data/trades";

export default function Plumbers() {
  return <TradePage trade={trades.plumbers} />;
}
